import { InstanceData, InstanceDataType } from '../../data';
import { IActiveInfo } from '../type';

/** 获取激活的画布信息 */
export const getActiveInfo = (identity: string, key: string) => {
    if (!key) return null;
    return InstanceData.getData(identity, InstanceDataType.ActiveInfo)?.[key] as IActiveInfo;
};

/** 设置激活的画布信息 */
export const setActiveInfo = (identity: string, key: string, data: IActiveInfo) => {
    let res: Record<string, unknown> = InstanceData.getData(identity, InstanceDataType.ActiveInfo);
    if (!res) {
        res = {};
        InstanceData.setData(identity, InstanceDataType.ActiveInfo, res);
    }
    res[key] = data;
};

/** 删除激活的画布信息 */
export const delActiveInfo = (identity: string, key: string) => {
    const res: Record<string, unknown> = InstanceData.getData(identity, InstanceDataType.ActiveInfo);
    if (!res) return;
    delete res[key];
};
